// Copyright (C) 2017-2023 Smart code 203358507

const SpeedMenu = require('./SpeedMenu');

module.exports = SpeedMenu;
